module.exports = __webpack_public_path__ + "static/media/tractor_green.c115d4b9.svg";